import moment from "moment";
import "moment/locale/id";
import { CurrencyFormat } from "../../../components/helpers";

export const convertExtensionCampaign = (data, outlet, category) => {
  let convertedExtensionnCampaign = [];

  if (!data) return [];

  data.forEach((item, index) => {
    let startDate = moment(item.start_date).format("DD/MM/YYYY");
    let endDate = moment(item.end_date).format("DD/MM/YYYY");
    convertedExtensionnCampaign.push({
      item: item,
      key: index + 1,
      paymentType:
        item.payment_type === "balloon_payment"
          ? "Balloon Payment"
          : item.payment_type === "installment"
          ? "Installment"
          : null,
      campaignName: item.name,
      tenorType:
        item.tenor_type === "reguler"
          ? "Reguler"
          : item.tenor_type === "non_reguler"
          ? "Non-Reguler"
          : null,
      maxExtension: `${item.max_extension} Kali`,
      minLoan: `Rp ${CurrencyFormat(item.min_loan_rupiah)}`,
      maxLoan: `Rp ${CurrencyFormat(item.max_loan_rupiah)}`,
      capitalLoan:
        item.capital_loan_rupiah !== 0
          ? `Rp ${CurrencyFormat(item.capital_loan_rupiah)}`
          : `${item.capital_loan_percentage} %`,
      feeAdminRupiah: `Rp ${CurrencyFormat(item.fee_admin_rupiah)}`,
      feeAdminPercent: `${item.fee_admin_percentage} %`,
      feeSaving:
        item.fee_saving_assurance_rupiah !== 0
          ? `Rp ${CurrencyFormat(item.fee_saving_assurance_rupiah)}`
          : `${item.fee_saving_assurance_percentage} %`,
      date: moment().isBetween(moment(item.start_date), moment(item.end_date))
        ? "Aktif"
        : moment().isAfter(moment(item.end_date))
        ? "Kadaluarsa"
        : moment().isBefore(moment(item.start_date))
        ? `${startDate} sampai ${endDate}`
        : null,
      category:
        item.promo_extension_products?.length === category
          ? `Semua Kategori Produk`
          : item.promo_extension_products?.map((e, index) =>
              index + 1 === item.promo_extension_products?.length
                ? `${e.product_category.name}`
                : `${e.product_category.name}, `
            ),
      tenorPerLoan:
        item?.tenor_type === "non_reguler" &&
        item?.promo_extension_tenors[0]?.days > 120
          ? "120 Hari"
          : `${item?.promo_extension_tenors[0]?.days} Hari`,
      totalTenor: `${item?.promo_extension_tenors[0]?.days} Hari`,
      revaluasi:
        item.revaluation_rupiah !== 0
          ? `Rp ${CurrencyFormat(item.revaluation_rupiah)}`
          : `${item.revaluation_percentage} %`,
      outlet:
        item.promo_loan_outlets?.length === outlet
          ? "Semua Outlet"
          : item.promo_extension_outlets?.map((e, index) =>
              e.outlet_id === 0
                ? "-"
                : index + 1 === item.promo_extension_outlets?.length
                ? `${e.outlet.name}`
                : `${e.outlet.name}, `
            ),
      notificationGroup: item.notification_group_id,
      gracePeriod: `${item?.grace_period} Hari`,
      maxLate: `${item?.max_late} Hari`,
    });
  });
  return convertedExtensionnCampaign;
};
